export const DEFAULT_READ_TIMEOUT_MS = 12000;

// Apply a deadline only to read requests. Mutations, uploads, payments and AI
// generation have different completion/idempotency requirements and must opt in
// explicitly instead of inheriting a global Axios timeout.
export const withReadPolicy = (config = {}, timeout = DEFAULT_READ_TIMEOUT_MS) => ({
  ...config,
  timeout: config.timeout ?? timeout,
});

export const isRequestTimeout = (error) =>
  error?.code === "ECONNABORTED" ||
  error?.code === "ETIMEDOUT" ||
  error?.name === "TimeoutError";
